// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2489":"1df4952315bc5d81","4062":"1176f13ce200080d"}[chunkId] + ".css";
};